import { createApi } from '@reduxjs/toolkit/query/react'
import { createNeighborhoodAwareBaseQuery } from '../../../Utils/baseQuery'

export const adsApiService = createApi({
  reducerPath: 'adsApi',
  baseQuery: createNeighborhoodAwareBaseQuery('/ads/'),
  endpoints: (builder) => ({
    getAds: builder.query({
      query: (args) => ({
        url: args?.id ? `get/${args?.id}` : `get`,
        method: "GET",
        params: args?.id ? {} : args
      }),
      keepUnusedDataFor: 0
    }),
    handleStatus: builder.mutation({
      query: (body) => ({
        url: `handle-status/${body.id}`,
        method: "PATCH",
        body: body?.payload
      })
    }),
    addBadge: builder.mutation({
      query: (payload) => ({
        url: 'create',
        method: 'POST',
        body: payload
      })
    }),
    updateBadge: builder.mutation({
      query: (payload) => ({
        url: `update/${payload._id}`,
        method: 'PUT',
        body: payload
      })
    }),
  })
})

export const {
  useGetAdsQuery,
  useAddBadgeMutation,
  useUpdateBadgeMutation,
  useHandleStatusMutation
} = adsApiService